<template>
  <div>
    <div class="mb-5">
      <div>
        <checkbox class="b-checkbox" v-model="isPermanent">{{$t('CONTENT.assets.perpetual')}}</checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import ChangeIsPermanent from "../../models/commands/ChangeIsPermanent";
import dateConverter from "../../../../utils/converters/date.converter";
export default {
  props: {
    assetComponent: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isPermanent: true
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.isPermanent = this.assetComponent.isPermanent;
    },

    cancel() {
      this.init();
    },

    save() {
      const command = new ChangeIsPermanent(
        this.assetComponent.idInDB,
        this.isPermanent
      );
      this.$store.commit("eventRegistryPlugin/addOrUpdateCommand", command);
      return true;
    }
  }
};
</script>

<style>
</style>
